import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Justin`}</h1>
    <p>{`Founder @ `}<a parentName="p" {...{
        "href": "https://www.pokeranks.com",
        "title": "PokéRanks"
      }}>{`PokéRanks`}</a>{` `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      